module.exports = __webpack_public_path__ + "media/snd_giftout.9865c8c7.wav";